const headers = {
  name: "Services",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "select",
      name: "sort",
      placeholder: "Sort",
      allowClear: true,
      showSearch: false,
      filterOption: true,
      value: null,
      options: [
        { value: 0, label: "Name (A-Z)" },
        { value: 1, label: "Name (Z-A)" },
        { value: 2, label: "Price (Low)" },
        { value: 3, label: "Price (High)" },
      ],
    },
    {
      type: "filter",
      name: "category",
      placeholder: "Category",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      api: "get-all-service-categories",
      value: null,
      options: null,
    },
  
    {
      type: "filter",
      name: "status",
      placeholder: "Status",
      value: null,
      allowClear: true,
      showSearch: false,
      filterOption: true,
      options: [
        { value: 0, label: "Inactive" },
        { value: 1, label: "Active" },
      ],
    },
    {
      type: "add",
      path: "/app/services/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Services",
        path: "",
      },
      {
        name: "Categories",
        path: "/app/services/categories",
      },
    ],
    total: [
      { value: 0, label: "Total" },
      { value: 0, label: "Active" },
      { value: 0, label: "Inactive" },
      { value: 0, label: "Standard" },
      { value: 0, label: "Package" },
    ],
  },
};

export default headers;